import React, { useState } from 'react';
import AssesmentDetails from '../components/Programs/AssesmentDetails';
import Aside from '../modules/SideNav/Aside';

function AssesmentDetailsLayout() {
    const rtl = false;

    const [toggled, setToggled] = useState(false);

    const handleToggleSidebar = value => {
        setToggled(value);
    };

    return (
        <div className={`app ${rtl ? 'rtl' : ''} ${toggled ? 'toggled' : ''}`}>
            <Aside
                rtl={rtl}
                toggled={toggled}
                handleToggleSidebar={handleToggleSidebar}
            />
            <AssesmentDetails handleToggleSidebar={handleToggleSidebar} />
        </div>
    );
}

export default AssesmentDetailsLayout;
